
import axios from "axios";
import services from "@/config/services";
import authHeader from "../auth/auth-header";
import Cookies from "js-cookie";
import FileManager from "@/services/ask-file-manager/index.js";

const DEFAULT_PRIVATE_BY_NOTE_STATES = [
  "completamento",
  // "sopralluogo",
  // "prima pianificazione",
];

export default class CaricamentoService {
  constructor(eventBus) {
    this.eventBus = eventBus;
    this.baseUrl = `${services.ask_pratiche.url}`;
    this.baseUrlApi = `${services.ask_api.url}`;
    this.baseUrlScraper = `${services.ask_pratiche_scraper.url}`
    this.filemanager = new FileManager();
    axios.interceptors.request.use((req) => {
      req.headers["Authorization"] = authHeader();
      req.headers["Params"] =
        Cookies.get("google_access_token") || Cookies.get("ask_access_token");
      // this.eventBus.emit('data-loading');
      return req;
    });
  }

  getPrivateByNoteRule(status, note, managedStates = DEFAULT_PRIVATE_BY_NOTE_STATES) {
    const normalizeStatus = (value) =>
      (typeof value === "string" ? value : value?.stato || "")
        .trim()
        .toLowerCase();

    const normalizedStatus = normalizeStatus(status);
    const isManaged = managedStates.some(
      (managedStatus) => normalizeStatus(managedStatus) === normalizedStatus
    );

    return {
      isManaged,
      privato: isManaged ? (/\bRT\b/i.test(note || "") ? 1 : 0) : null,
    };
  }

  syncPrivateByNote(pratica, managedStates = DEFAULT_PRIVATE_BY_NOTE_STATES) {
    const rule = this.getPrivateByNoteRule(
      pratica?.selectedStato,
      pratica?.nota,
      managedStates
    );

    if (pratica && rule.isManaged) {
      pratica.privato = rule.privato;
    }

    return rule;
  }

  async getCtrsComputed() {
    let items = {};
    const url = `${this.baseUrl}/get-ctrs-computed`;
    try {
      let res = await axios.get(url);
      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }


  async getListCessazione(page = 1, perPage = 30, stato = null, search = null) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListCessazione`;
      const response = await axios.get(url, {
        params: {
          page,
          per_page: perPage,
          stato,
          search,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
  async updateDataFinePdp({ codPratica, tipo, code, dataFine }) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/updateDataFinePdp`;
    try {
      const response = await axios.post(url, {
        cod_pratica: codPratica,
        tipo,
        code,
        data_fine: dataFine,
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiornamento della data fine:", error);
      throw error;
    }
  }

  async getListModificaMc1(page = 1, perPage = 30, stato = null, search = null) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListModificaMc1`;
      const response = await axios.get(url, {
        params: {
          page,
          per_page: perPage,
          stato,
          search,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
  async getListModificaPosaContatore(page = 1, perPage = 30, stato = null, search = null, tipo = null) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListModificaPosaContatore`;
      const response = await axios.get(url, {
        params: {
          page,
          per_page: perPage,
          stato,
          search,
          tipo,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
  async updateCodePosaContatore(id, code, completamentoInCorso = false, tipo = null) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/updateCodePosaContatore`;
      const response = await axios.post(url, {
        id,
        code,
        completamento_in_corso: completamentoInCorso,
        tipo,
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiornamento del Code:", error);
      throw error;
    }
  }
  async associaMatricePosaContatore({ matrice_id, id_pratica, code, tipo, precheck, in_nuova_posa }) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/associaMatricePosaContatore`;
      const response = await axios.post(url, {
        matrice_id,
        id_pratica,
        code,
        tipo,
        precheck,
        in_nuova_posa,
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'associazione della matrice alla pratica:", error);
      throw error;
    }
  }
  async autovalidaCaricamentoById(matriceId) {
    try {
      const url = `${this.baseUrl}/autovalidazione-by-id/${matriceId}`;
      const response = await axios.post(url, {
        stamp_esito: false,
        no_session: true,
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'autovalidazione del caricamento:", error);
      throw error;
    }
  }
  async forzaCaricamento(matriceId) {
    try {
      const url = `${this.baseUrl}/multisito/forza-caricamento`;
      const response = await axios.post(url, {
        id: matriceId,
        no_session: true,
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento forzato:", error);
      throw error;
    }
  }
  async cercaMatricePerCode({ code, tipo }) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/cercaMatricePerCode`;
      const response = await axios.post(url, { code, tipo });
      return response.data;
    } catch (error) {
      console.error("Errore durante la ricerca della matrice per Code:", error);
      throw error;
    }
  }

  async getListSpostamentoContatore(page = 1, perPage = 30, stato = null, search = null) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListSpostamentoContatore`;
      const response = await axios.get(url, {
        params: {
          page,
          per_page: perPage,
          stato,
          search,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async getListVerificaContatore(page = 1, perPage = 30, stato = null, search = null) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListVerificaContatore`;
      const response = await axios.get(url, {
        params: {
          page,
          per_page: perPage,
          stato,
          search,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async getListVoltura() {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListVoltura`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
  async getListVolturaType(type, status = []) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListVoltura`;
      const response = await axios.post(url,{type, status});
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
    async updateUddOrProtocolloSII(id, field, value) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/updateUddOrProtocolloSII`;
    const data = { id, [field]: value };
  
    try {
      const response = await axios.post(url, data);
      return response.data;
    } catch (error) {
      console.error(`Errore durante l'aggiornamento del campo ${field}:`, error);
      throw error;
    }
  }

  async getListSubentro() {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListSubentro`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
  async getListSubentroType(type, status = []) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListSubentro`;
      const response = await axios.post(url,{type, status});
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
  async getListAttivazionePreposatoType(type, status = []) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListAttivazionePreposato`;
      const response = await axios.post(url, {type, status});
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
  async getListVT4(type, status = []) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListVT4`;
      const response = await axios.post(url,{type, status});
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
  async resetPratica(filename, supply_id){
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/reset-pratica`;
      const data = {filename, supply_id}
      const response = await axios.post(url, data);
      return response.data;
    } catch (error) { 
      console.error(
        "Errore durante il ripristino della pratica:",
        error
      );
      throw error;
    }
  }
  async getStatoPratica() {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getStatoPratica`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }
  async getStatusPratica(idPratica, typefile) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getStatusPratica`;
      const response = await axios.get(url, {
        params: {
          id_pratica: idPratica,
          typefile,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async getPraticaHistory(idPratica, typefile) {
    if (["Voltura", "Subentro"].includes(typefile)) {
      const response = await this.getStatusPraticaVolturaESubentro(idPratica, typefile);
      return Array.isArray(response?.stati) ? response.stati : [];
    }

    const response = await this.getStatusPratica(idPratica, typefile);
    const normalize = (value) => String(value ?? "").trim().toLowerCase();
    const stati = Array.isArray(response?.stati) ? response.stati : [];

    return stati.filter(
      (stato) =>
        normalize(stato.cod_pratica) === normalize(idPratica) &&
        normalize(stato.type_file) === normalize(typefile)
    );
  }

  async getStatusPraticaVolturaESubentro(idPratica, typefile) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getStatusPraticaVolturaESubentro`;

      const response = await axios.get(url, {
        params: {
          id_pratica: idPratica,
          typefile: typefile,
        },
      });

      return response.data;
    } catch (error) {
      console.error(
        "Errore durante il recupero dello storico pratica voltura/subentro:",
        error
      );
      throw error;
    }
  }

  async updateStatusPratica(praticaId, nuovoStato) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/updatePraticaStatus`;
      const data = {
        id: praticaId,
        new_status: nuovoStato,
      };
      const response = await axios.post(url, data);
      return response.data;
    } catch (error) { 
      console.error(
        "Errore durante l'aggiornamento dello stato della pratica:",
        error
      );
      throw error;
    }
  }
  async aggiornaNotePratica(praticaId, nuovaNota, nuovoStato, statoNome,nomeCompleto, privato, typefile,code, tipologia) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/aggiornaNotePratica`;
      const data = {
        id_pratica: praticaId,
        nota: nuovaNota,
        new_status: nuovoStato,   
        stato_nome: statoNome,
        nome_completo: nomeCompleto,    
        privato: privato,
        typefile: typefile,
        code: code,
        tipologia: tipologia,
      };
      const response = await axios.post(url, data);
      return response.data;
    } catch (error) {
      console.error(
        "Errore durante l'aggiornamento delle note della pratica:",
        error
      );
      throw error;
    }
  }
  async aggiornaNotePraticaVolturaESubentro(praticaId, nuovaNota, nuovoStato, privato,code,denominazione,tipologia) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/aggiornaNotePraticaVolturaESubentro`;
      const stato =
        nuovoStato && typeof nuovoStato === "object"
          ? {
              ...nuovoStato,
              numero: nuovoStato.numero ?? nuovoStato.id,
            }
          : nuovoStato;
      const data = {
        id_pratica: praticaId,
        nota: nuovaNota,
        numero: stato,
        code: code,
        denominazione: denominazione,
        privato: privato,
        tipologia: tipologia,
      };
      const response = await axios.post(url, data);
      return response.data;
    } catch (error) {
      console.error(
        "Errore durante l'aggiornamento delle note della pratica:",
        error
      );
      throw error;
    }
  }
  async uploadPreventivoFirmato(requestData) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadPreventivoFirmato`;
    const fd = new FormData();
    const files = Array.isArray(requestData.files)
      ? requestData.files
      : [requestData.file];
    files.forEach((file) => {
      fd.append("file[]", file);
    });
    fd.append("id", requestData.id);
    fd.append("type_file", requestData.type_file);
    const response = await axios.post(url, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }

  async downloadPreventivoFirmato(id, typeFile, fileId) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadPreventivoFirmato`;
    const params = {
      id,
      type_file: typeFile,
    };
    if (fileId) {
      params.file_id = fileId;
    }
    const response = await axios.get(url, {
      params,
      responseType: "blob",
    });
    const contentDisposition = response.headers["content-disposition"] || "";
    const match = contentDisposition.match(/filename="?([^";]+)"?/i);
    const fileName = match ? match[1] : "preventivo-firmato";
    const blob = new Blob([response.data]);
    const urlBlob = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = urlBlob;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(urlBlob);
  }

  async elencoPreventiviFirmati(typeFile) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/elencoPreventiviFirmati`;
    const response = await axios.get(url, {
      params: {
        type_file: typeFile,
      },
    });
    return response.data?.ids || [];
  }

  async elencoFilePreventivoFirmato(id, typeFile) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/elencoPreventiviFirmati`;
    const response = await axios.get(url, {
      params: {
        id,
        type_file: typeFile,
      },
    });
    return response.data?.files || [];
  }

  async uploadPreventiviPratiche(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadPreventiviPratiche`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("tipo", requestData.tipo);
      
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadPreventivoPratica(id, tipo) {
    try {
      if (!tipo) {
        throw new Error("Il parametro 'tipo' non è stato definito");
      }
  
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadPreventivoPratica?id=${id}&tipo=${tipo}`;
  
      const response = await axios.get(url, {
        responseType: "blob",
      });
  
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        ? contentDisposition.split(";")[1].split("filename=")[1].trim()
        : "preventivo.zip";
  
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
  
      document.body.appendChild(link);
      link.click();
  
      document.body.removeChild(link);
  
      console.log("Preventivo scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del preventivo:", error);
      throw error;
    }
  }
  async uploadPreventiviPraticheVolturaESubentro(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadPreventiviPraticheVolturaESubentro`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("code", requestData.code);
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadPreventivoPraticaVolturaESubentro(id,code) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadPreventivoPraticaVolturaESubentro?id=${id}&code=${code}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Preventivo scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del preventivo:", error);
      throw error;
    }
  }
  async uploadPreventiviPraticheVT4(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadPreventiviPraticheVT4`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("code", requestData.code);
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadPreventivoPraticaVT4(code, id) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadPreventivoPraticaVT4?id=${id}&code=${code}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Preventivo scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del preventivo:", error);
      throw error;
    }
  }
  async uploadAllegatiPratiche(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadAllegatiPratiche`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("code", requestData.code);
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadAllegatoPratica(id,codecliente) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadAllegatoPratica?id=${id}&code=${codecliente}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Allegato scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del Allegato:", error);
      throw error;
    }
  }

  async uploadAllegatiPraticheVerificaContatore(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadAllegatiPraticheVerificaContatore`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("code", requestData.code);
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadAllegatoPraticaVerificaContatore(id,code) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadAllegatoPraticaVerificaContatore?id=${id}&code=${code}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Allegato scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del Allegato:", error);
      throw error;
    }
  }

  async uploadAllegatiPraticheSpostamentoContatore(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadAllegatiPraticheSpostamentoContatore`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("code", requestData.code);
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadAllegatoPraticaSpostamentoContatore(codecliente, id) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadAllegatoPraticaSpostamentoContatore?id=${id}&code=${codecliente}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Allegato scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del Allegato:", error);
      throw error;
    }
  }
  async uploadAllegatiPraticheMc1(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadAllegatiPraticheMc1`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("code", requestData.code);
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadAllegatoPraticaMc1(codecliente, id) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadAllegatoPraticaMc1?id=${id}&code=${codecliente}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Allegato scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del Allegato:", error);
      throw error;
    }
  } 
  async uploadAllegatiPratichePosaContatore(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadAllegatiPratichePosaContatore`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadAllegatoPraticaPosaContatore(id) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadAllegatoPraticaPosaContatore?id=${id}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Allegato scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del Allegato:", error);
      throw error;
    }
  }
  async uploadAllegatiPraticheVoltura(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadAllegatiPraticheVoltura`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("code", requestData.code);
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadAllegatoPraticaVoltura(code, id) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadAllegatoPraticaVoltura?id=${id}&code=${code}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Allegato scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del Allegato:", error);
      throw error;
    }
  }
  async uploadAllegatiPraticheSubentro(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadAllegatiPraticheSubentro`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("code", requestData.code);
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadAllegatoPraticaSubentro(code, id) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadAllegatoPraticaSubentro?id=${id}&code=${code}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Allegato scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del Allegato:", error);
      throw error;
    }
  }
  async uploadAllegatiPraticheVT4(requestData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadAllegatiPraticheVT4`;
      let fd = new FormData();
      fd.append("file", requestData.file);
      fd.append("id", requestData.id);
      fd.append("code", requestData.code);
      const response = await axios.post(url, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento del file:", error);
      throw error;
    }
  }
  async downloadAllegatoPraticaVT4(code, id) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/downloadAllegatoPraticaVT4?id=${id}&code=${code}`;
      const response = await axios.get(url, {
        responseType: "blob",
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        .split(";")[1]
        .split("filename=")[1]
        .trim();
      const blob = new Blob([response.data]);
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("Allegato scaricato con successo:", fileName);
    } catch (error) {
      console.error("Errore durante il download del Allegato:", error);
      throw error;
    }
  }
  async aggiungiPraticaConferma(nuovaPratica) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadNewPraticaCessazione`;
      const response = await axios.post(url, {
        id: nuovaPratica.id,
        code: nuovaPratica.code,
        matricola: nuovaPratica.matricola,
        udd: nuovaPratica.udd,
        nomerappresentante: nuovaPratica.nomerappresentante,
        cognomerappresentante: nuovaPratica.cognomerappresentante,
        codicePratica: nuovaPratica.codicePratica,
        dataDaNonEseguirePrimaDel: nuovaPratica.dataDaNonEseguirePrimaDel,
        infoContatore: nuovaPratica.infoContatore,
        telefono: nuovaPratica.telefono,
        codiceAteco: nuovaPratica.codiceAteco,
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiunta della nuova pratica:", error);
      throw error;
    }
  }
  async aggiungiPraticaConfermaModificaMc1(nuovaPratica) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadNewPraticaModificaMc1`;
      const response = await axios.post(url, {
        id: nuovaPratica.id,
        code: nuovaPratica.code,
        nomerappresentante: nuovaPratica.nomerappresentante,
        cognomerappresentante: nuovaPratica.cognomerappresentante,
        codicefiscale: nuovaPratica.codicefiscale,
        telefono: nuovaPratica.telefono,
        udd: nuovaPratica.udd,
        codicePratica: nuovaPratica.codicePratica,
        potenzaDisponibile: nuovaPratica.potenzaDisponibile,
        potenzaImpegnata: nuovaPratica.potenzaImpegnata,
        stagionalità: nuovaPratica.stagionalità,
        tensione: nuovaPratica.tensione,
        tipologiaContrattuale: nuovaPratica.tipologiaContrattuale,
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiunta della nuova pratica:", error);
      throw error;
    }
  }
  async aggiungiPraticaConfermaModificaPosaContatore(nuovaPratica) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadNewPraticaModificaPosaContatore`;

      const response = await axios.post(url, {
        code: nuovaPratica.code,
        matricola: nuovaPratica.matricola,
        udd: nuovaPratica.udd,
        nomerappresentante: nuovaPratica.nomerappresentante,
        cognomerappresentante: nuovaPratica.cognomerappresentante, 
        codicePratica: nuovaPratica.codicePratica,
        ragionesociale: nuovaPratica.ragionesociale,
        partitaIva: nuovaPratica.partitaIva,
        email: nuovaPratica.email,
        codiceFiscale: nuovaPratica.codiceFiscale,
        telefono: nuovaPratica.telefono,
        intestatario: nuovaPratica.intestatario,
        connessione: nuovaPratica.connessione,
        sedeLegale: nuovaPratica.sedeLegale,
        potenzaDisponibile: nuovaPratica.potenzaDisponibile,
        potenzaImpegnata: nuovaPratica.potenzaImpegnata,
        stagionalità: nuovaPratica.stagionalità,
        tensione: nuovaPratica.tensione,
        tipologiauso: nuovaPratica.tipologiauso,
        tipologiaContrattuale: nuovaPratica.tipologiaContrattuale,
        distributore: nuovaPratica.distributore,
        categoria_uso: nuovaPratica.categoria_uso,
        tipoConnessione: nuovaPratica.tipoConnessione,
        dataFineTemporanea: nuovaPratica.dataFineTemporanea,
        disalimentabile: nuovaPratica.disalimentabile,
        remi: nuovaPratica.remi, 
        connessioneGas: nuovaPratica.connessioneGas, 
        portataKwh: nuovaPratica.portataKwh, 
        indirizzo: nuovaPratica.indirizzo, 
        classeMisuratore: nuovaPratica.classeMisuratore,
        tipoPratica: nuovaPratica.tipoPratica,
        agente_id: nuovaPratica.agente_id
      });
  
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiunta della nuova pratica:", error);
      throw error;
    }
  }
  async aggiungiPraticaSpostamentoContatore(nuovaPratica) {
    try {
      console.log("Dati ricevuti in aggiungiPraticaSpostamentoContatore:", nuovaPratica);
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadNewPraticaSpostamentoContatore`;
      const response = await axios.post(url, {
        id: nuovaPratica.id,
          code: nuovaPratica.code,
          ragionesociale: nuovaPratica.ragionesociale,
          email: nuovaPratica.email,
          nomerappresentante: nuovaPratica.nomerappresentante,
          cognomerappresentante: nuovaPratica.cognomerappresentante,
          piva: nuovaPratica.piva,
          telefono: nuovaPratica.telefono,
          indirizzo: nuovaPratica.indirizzo,
          cap: nuovaPratica.cap,
          pr: nuovaPratica.pr,
          tipo: nuovaPratica.tipo,
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiunta della nuova pratica:", error);
      throw error;
    }
  }

  async aggiungiPraticaVerificaContatore(nuovaPratica) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/uploadNewPraticaVerificaContatore`;
      const response = await axios.post(url, {
        code: nuovaPratica.code,
        nome: nuovaPratica.nome,
        cognome: nuovaPratica.cognome,
        intestatario: nuovaPratica.intestatario,
        numero_telefono: nuovaPratica.telefono,
        email: nuovaPratica.email,
        ragsoc: nuovaPratica.ragsoc,
        piva: nuovaPratica.piva,
        codice_fiscale: nuovaPratica.codiceFiscale,
        motivazione: nuovaPratica.motivazione
      });
      console.log("Dati ricevuti dalla chiamata API:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiunta della nuova pratica:", error);
      throw error;
    }
  }

  async aggiungiUddECodicePratica(praticaId, nuovoUdd, nuovoCodicePratica, nuovoDistributore, tipoPratica) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/aggiungiUddECodicePratica`;
      const data = {
        id: praticaId,
        udd: nuovoUdd,
        codicePratica: nuovoCodicePratica,
        distributore: nuovoDistributore,
        tipoPratica: tipoPratica 
      };
      const response = await axios.post(url, data);
      return response.data;
    } catch (error) {
      console.error(
        "Errore durante l'aggiornamento di UDD e Codice Pratica:",
        error
      );
      throw error;
    }
  }
  async getFileCaricamento(matrice_id) {
    let items = [];
    const url = `${this.baseUrl}/multisito/get-file-caricamento-${matrice_id}`;
    try {
      let res = await axios.get(url);
      items = res.data;
    } catch (err) {
      console.error('Errore durante il caricamento dei file:', err);
    }
    return { items };
  }
  async downloadPdf(matrice_id, filename){
    const url = `${this.baseUrl}/multisito/download-file-caricamento`;
    try {
      let res = await axios({url,
          method: 'POST',
          data: {
            matrice_id: matrice_id,
            file: filename,
            // dir: directory
          },
          responseType: 'blob',
        })
      //this.eventBus.emit('data-load-success', {message: res.data})
      this.filemanager.download(res)
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')   
    }
  }
  async downloadZip(matrice_id){
    const url = `${this.baseUrl}/multisito/download-zip-caricamento-${matrice_id}`;
    try {
        let res = await axios({url,
            method: 'GET',
            responseType: 'blob'
        })
      //this.eventBus.emit('data-load-success', {message: res.data})
      this.filemanager.download(res)
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')   
    }
  }
  async getManualPracticeSettings(pratica, type) {
    const res = await axios.get(`${this.baseUrlScraper}/configurazione-gestione-manuale`, {
      params: { pratica, type },
    });
    return res.data;
  }
  async getTemplatesAvailable() {
    const res = await axios.get(`${this.baseUrl}/switch-in/templates/available`);
    return res.data;
  }
  async downloadFilePratica(fd, type_file, provider = 'agf') {
    const url = `${this.baseUrlScraper}/scarica-${type_file}`;
    if (type_file === 'vt4') fd.set('provider', provider);
    try {
      const res = await axios({
        url,
        method: 'POST',
        data: fd,
        responseType: 'blob',
      });
      this.filemanager.download(res);
      return this.filemanager.getFileName(res);
    } catch (error) {
      // Axios keeps JSON error responses as Blob when downloading a file.
      try {
        const responseData = error.response?.data;
        const data = typeof Blob !== 'undefined' && responseData instanceof Blob
          ? JSON.parse(await responseData.text())
          : responseData;
        if (typeof data?.message === 'string' && data.message.trim()) {
          error.downloadMessage = data.message;
        }
      } catch {
        // Preserve the original error if the server returned HTML or invalid JSON.
      }
      throw error;
    }
  }
  async getTypesStatoPratica() {
    let items = {};
    const url = `${this.baseUrlApi}/management/get-types-stato-pratica`;
    try {
      let res = await axios.get(url);
      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }
  async getResponsePratica(filename) {
    const response = await axios.get(`${this.baseUrlScraper}/dettaglio-risposta-pratica`, {
      params: { filename }
    });
    return response.data;
  }
  async getRequestPratica(filename, forDelete = false) {
    const response = await axios.get(`${this.baseUrlScraper}/dettaglio-richiesta-pratica`, {
      params: { filename, for_delete: forDelete ? 1 : 0 }
    });
    return response.data;
  }
  async deleteRequestPratica(payload) {
    const response = await axios.post(`${this.baseUrlScraper}/elimina-richiesta-pratica`, payload);
    return response.data;
  }
  async getRequestDeletionHistory(filename) {
    const response = await axios.get(`${this.baseUrlScraper}/storico-eliminazioni-richiesta`, {
      params: { filename }
    });
    return response.data;
  }

  async getManualPractice(filename) {
    const response = await axios.get(`${this.baseUrlScraper}/esiti-pratiche`, { params: { filename } });
    return response.data;
  }

  async saveManualPractice(filename, id, esito, motivazione) {
    const response = await axios.post(`${this.baseUrlScraper}/esiti-pratiche/salva`, { filename, id, esito, motivazione });
    return response.data;
  }

  async completeManualPractice(filename) {
    const response = await axios.post(`${this.baseUrlScraper}/esiti-pratiche/completa`, { filename });
    return response.data;
  }

  async getPratiche(swo = false){
    let items = []
    const url = `${this.baseUrlScraper}/file-pratiche/${swo}`
    try {
        let res = await axios.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      // this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }
  async saveIdPratica(filename, id){
    let url = `${this.baseUrlScraper}/associa-file-pratica`
    let fd = new FormData();
    fd.append('filename', JSON.stringify(filename));
    fd.append('id', JSON.stringify(id));
    let res = await axios({
        url,
        method: 'POST',
        data: fd,
    })
    return res.data
  }
  async downloadFileName(file){
    const url = `${this.baseUrlScraper}/scarica-file-${file}`
    let res = await axios({
        url,
        method: 'GET',
        responseType: 'blob',
    })
    this.filemanager.download(res)
  }
  async uploadFilePratica(file, id, type, provider = 'agf'){
    let url = `${this.baseUrlScraper}/invia-risposta-pratica`
    let fd = new FormData();
    fd.append('type', JSON.stringify(type));
    fd.append('id', id);
    fd.append('provider', provider);
    fd.append('files[]', file); 
    let res = await axios({
        url,
        method: 'POST',
        data: fd,
    })
    return res.data
  }
  async checkFatturaAgyo(numero) {
    const url = `${this.baseUrl}/checkFatturaAgyo/${numero}`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante la verifica della fattura:", error);
      throw error;
    }
  }
  async getPraticheStats() {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getPraticheStats`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero delle statistiche:", error);
      throw error;
    }
  }
  async salvaPreventivoPartica(preventivoData) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/salva-preventivo-pratica`;
      const response = await axios.post(url, preventivoData);
      console.log("Risposta salvataggio preventivo:", response.data);
      return response.data;
    } catch (error) {
      console.error("Errore durante il salvataggio del preventivo:", error);
      throw error;
    }
  }
  async getAllPreventiviPratica() {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/get-all-preventivi-pratica`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei preventivi:", error);
      throw error;
    }
  }
  async associaFattura({ cod_pratica, numero_fattura }) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/associa-preventivo-a-fattura`;
      const { data } = await axios.get(url, { params: {
        cod_pratica,
        numero_fattura
      }});
      return data;
    } catch (error) {
      console.error("Errore durante l'associazione della fattura:", error);
      throw error;
    }
  }
  async getPreventivoPratica(codPratica, typePratica) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/get-all-preventivi-pratica`;
      const response = await axios.get(url);
      
      const preventivo = response.data.find(p => 
        p.cod_pratica === codPratica && 
        p.type_pratica === typePratica
      );
      
      return { data: preventivo };
    } catch (error) {
      console.error("Errore durante il recupero del preventivo:", error);
      throw error;
    }
  }

  async getAgents() {
    try {
      const url = `${this.baseUrl}/get-agenti`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero degli agenti:", error);
      throw error;
    }
  }

   async getAgentiSuggeriti(ricerca) {
    try {
      const url = `${this.baseUrl}/get-agenti-suggeriti`;
      const response = await axios.get(url, { params: { ricerca } });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero degli agenti:", error);
      throw error;
    }
  }

  async completamentoCessazione(id, tipologia, dataCompletamento) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/completamento-cessazione`;
      const response = await axios.post(url, {
        id: id,
        tipologia: tipologia,
        data_completamento: dataCompletamento
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiornamento della data di completamento:", error);
      throw error;
    }
  }
  async completamentoPosaContatore(id, tipologia, dataCompletamento) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/completamento-posa-contatore`;
      const response = await axios.post(url, {
        id: id,
        tipologia: tipologia,
        data_completamento: dataCompletamento
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiornamento della data di completamento:", error);
      throw error;
    }
  }
  async completamentoverifica(id, tipologia, dataCompletamento) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/completamento-verifica-contatore`;
      const response = await axios.post(url, {
        id: id,
        tipologia: tipologia,
        data_completamento: dataCompletamento
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiornamento della data di completamento:", error);
      throw error;
    }
  }
  async completamentoDataInizio(id, code, dataCompletamento) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/completamento-data-inizio`;
      const response = await axios.post(url, {
        id: id,
        code: code,
        data_completamento: dataCompletamento
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiornamento della data di completamento:", error);
      throw error;
    }
  }

  async changePrivatePratica(idStato, isPrivate) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/changePrivatePratica`;
      const response = await axios.post(url, {
        id_stato: idStato,
        is_private: isPrivate
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiornamento della visibilità:", error);
      this.eventBus.emit("data-load-error", { message: error});
      throw error;
    }
  }
  async getCountPraticheNonLavorate() {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getCountPraticheNonLavorate`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero del count pratiche non lavorate:", error);
      throw error;
    }
  }
  async deletePraticaFromId(nomeTabella, idPratica, tipologia) {
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/delete-pratica-from-id`;
      const response = await axios.post(url, {
        nome_tabella: nomeTabella,
        id: idPratica,
        tipologia: tipologia
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante la cancellazione della pratica:", error);
      this.eventBus.emit("data-load-error", { message: error});
      throw error;
    }
  }
  async getListPraticheStalloIncall() {
    try {
      const url = `${this.baseUrl}/incall/pratiche-stallo`;
      const response = await axios.get(url);
      return {
        pending: response.data?.data || [],
        rejected: response.data?.rejected || [],
      };
    } catch (error) {
      console.error("Errore durante il recupero delle pratiche da confermare:", error);
      throw error;
    }
  }
  async getCountPraticheStalloIncall() {
    try {
      const url = `${this.baseUrl}/incall/pratiche-stallo/count`;
      const response = await axios.get(url);
      return response.data?.count || 0;
    } catch (error) {
      console.error("Errore durante il conteggio pratiche da confermare:", error);
      return 0;
    }
  }
  async getPraticheStalloIncallStats() {
    try {
      const url = `${this.baseUrl}/incall/pratiche-stallo/stats`;
      const response = await axios.get(url);
      return response.data?.stats || null;
    } catch (error) {
      console.error("Errore durante il recupero delle statistiche Incall:", error);
      return null;
    }
  }
  async confermaPraticaStalloIncall(id, overrides = {}) {
    try {
      const url = `${this.baseUrl}/incall/pratiche-stallo/confirm`;
      const response = await axios.post(url, { id, overrides });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return error.response.data;
      }
      throw error;
    }
  }
  async scartaPraticaStalloIncall(id, nota = "") {
    try {
      const url = `${this.baseUrl}/incall/pratiche-stallo/reject`;
      const response = await axios.post(url, { id, nota });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return error.response.data;
      }
      throw error;
    }
  }
  async marcaLavorataPraticaStalloIncall(id) {
    try {
      const url = `${this.baseUrl}/incall/pratiche-stallo/lavorata`;
      const response = await axios.post(url, { id });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return error.response.data;
      }
      throw error;
    }
  }
  async downloadPraticaStalloIncall(id) {
    try {
      const url = `${this.baseUrl}/incall/pratiche-stallo/download-signed`;
      const response = await axios.post(url, { id }, { responseType: "blob" });
      this.filemanager.download(response);
      return response;
    } catch (error) {
      console.error("Errore durante il download del PDF firmato:", error);
      throw error;
    }
  }

  // Appuntamenti delle pratiche (ask_pratiche, PraticheAppuntamentiController)
  async aggiungiAppuntamentoPratica(payload) {
    try {
      const url = `${services.ask_pratiche_base.url}/api/pratiche-appuntamenti/aggiungi`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return error.response.data;
      }
      throw error;
    }
  }
  async aggiornaAppuntamentoPratica(payload) {
    try {
      const url = `${services.ask_pratiche_base.url}/api/pratiche-appuntamenti/aggiorna`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return error.response.data;
      }
      throw error;
    }
  }
  async eliminaAppuntamentoPratica(id) {
    try {
      const url = `${services.ask_pratiche_base.url}/api/pratiche-appuntamenti/elimina`;
      const response = await axios.delete(url, { data: { id } });
      return response.data;
    } catch (error) {
      if (error?.response?.data) {
        return error.response.data;
      }
      throw error;
    }
  }
}
